// extracted by mini-css-extract-plugin
export default {"analytics_card":"styles_analytics_card__pv8GK","title":"styles_title__WyC8M","data":"styles_data__bi8Dq","text":"styles_text__fGaDT"};